import { jsx as t } from "react/jsx-runtime";
import { d as l, ab as s, ac as d } from "../../vendor-EQDp64ng.js";
import { forwardRef as c } from "react";
import { stupidInvertClasses as n } from "../../utils/index.js";
import { ChildFilter as p } from "../../utils/ChildFilter/index.js";
import '../../assets/index13.css';const m = "_tooltip_xd40h_1", f = {
  tooltip: m
}, T = c(
  ({ placement: o = "top", __inverted: i, children: a }, e) => {
    const r = l(f.tooltip, i ? n() : void 0);
    return /* @__PURE__ */ t(s, { ref: e, placement: o, className: r, "data-component": "Tooltip", children: /* @__PURE__ */ t(p, { invalidChildren: ["a", "button", "iconbutton", "link"], children: a }) });
  }
), v = (o) => d({ ...o, closeDelay: 0, delay: o.delay === "immediate" ? 0 : 300 });
export {
  T as Tooltip,
  v as TooltipTrigger
};
